<template>
  <div class="product-add" v-loading="loading">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      <el-tab-pane label="规格库存" name="spec"></el-tab-pane>
      <el-tab-pane label="商品详情" name="content"></el-tab-pane>
      <!-- <el-tab-pane label="租赁设置" name="fenqi"></el-tab-pane> -->
      <!-- <el-tab-pane label="高级设置" name="buyset"></el-tab-pane> -->
    </el-tabs>
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="110px" v-if="!loading">
      <!--基础信息-->
      <Basic v-show="activeName == 'basic'"></Basic>
      <!--规格设置-->
      <Spec v-show="activeName == 'spec'"></Spec>
      <!--商品详情-->
      <Content v-show="activeName == 'content'"></Content>
      <!-- 分期设置 -->
      <fenqi v-show="activeName == 'fenqi'"></fenqi>
      <!--高级设置-->
      <Buyset v-show="activeName == 'buyset'"></Buyset>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" :loading="formStatus.loading" @click="onSubmit('edit')"
          :disabled="save_loading">发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from "@/api/product.js";
import Basic from "./part/Basic.vue";
import Spec from "./part/Spec.vue";
import Content from "./part/Content.vue";
import Buyset from "./part/Buyset.vue";
import fenqi from "./part/fenqi.vue";

import {
  formatModel
} from "@/utils/base.js";
export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    Buyset,
    // 分期设置
    fenqi,
  },
  data() {
    return {
      formStatus: { loading: false },
      /*租赁详情内容*/
      lease_description: "",
      common_description: "",
      activeName: "basic",
      /*商品ID*/
      product_id: 0,
      /*判断是编辑*/
      scene: "edit",
      /*是否正在加载*/
      loading: true,
      /*是否正在提交保存*/
      save_loading: false,
      /*form表单数据*/
      form: {
        model: {
          // 展示方式
          display: [],
        },
        /*商品分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*分销基础设置*/
        basicSetting: {},
        /*分销佣金设置*/
        agentSetting: {},
        audit_setting: {}
      },
      /*模型数据*/
      model: {
        lease_period_interval: '',
        hide: "",
        //常用说明
        commonImage: [],
        // 租赁说明
        contentImage: [],
        leaseImage: [],
        is_common_description: 0,
        is_lease_description: 0,
        /*商品合同名称*/
        product_desc: "",
        /*商品名称*/
        product_name: "",
        /*商品分类*/
        category_id: null,
        /*商品图片*/
        image: [],
        // 热点商品
        spimage: [],
        // 商品标签
        shop_label: [],
        is_picture: 0,
        contentImage: [],
        video_id: 0,
        poster_id: 0,
        /*商品卖点*/
        selling_point: "",
        /*规格类别,默认10单规格，20多规格*/
        spec_type: 10,
        /*库存计算方式,默认20付款减库存，10下单减库存*/
        deduct_stock_type: 20,
        /*单规格*/
        sku: {
          /*供货价*/
          product_price: 0,
          /*产品划线价*/
          line_price: 0,
          /*库存数量*/
          stock_num: 0,
          /*商品重量*/
          product_weight: 0,
          // 买断价格
          buy_out_price: 0,
          //  押金
          deposit: 0,
          /*商品编码*/
          product_no: "",
        },
        /*多规格类别*/
        spec_many: {
          /*多规格类别*/
          spec_attr: [],
          /*多规格表格数据*/
          spec_list: [],
        },
        /*商品详情内容*/
        content: "",
        /*运费模板ID*/
        delivery_id: "",
        /*商品状态*/
        product_status: 10,
        audit_status: 0,
        /*商品排序，默认100*/
        product_sort: 100,
        /*是否开启积分赠送,默认1为开启，0为关闭*/
        is_points_gift: 1,
        /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
        is_points_discount: 1,
        /*最大积分抵扣数量*/
        max_points_discount: 0,
        /*商品分销是否开启*/
        is_agent: 0,
        /*是否开启单独分销,默认0为关闭，1为开启*/
        is_ind_agent: 0,
        /*分销佣金类型,默认10为百分比，20为固定金额*/
        agent_money_type: 10,
        /*一级佣金*/
        first_money: null,
        /*二级佣金*/
        second_money: null,
        /*三级佣金*/
        third_money: null,
        /*是否虚拟商品*/
        is_virtual: 0,
        /*限购数量*/
        limit_num: 0,
        /*虚拟商品发货方式*/
        virtual_auto: 0,
        /*虚拟商品发货内容*/
        virtual_content: "",
        // 已售
        sales_initial: "",
        // 新品优惠
        xpyh: "",
        // 活动详情
        hdxq: "",
        // 开始时间
        kssj: "",
        tableData: [{
          lease_time: "12",
          val: "100",
          value: "100",
        },],
      },
    };
  },
  provide: function () {
    return {
      form: this.form,
      formStatus: this.formStatus
    };
  },
  created() {
    /*获取列表*/
    this.product_id = this.$route.query.product_id;
    this.scene = this.$route.query.scene;
    this.getData();
  },
  methods: {
    /**
     * 获取基础数据
     */
    getData: function () {
      let self = this;
      PorductApi.getEditData({
        product_id: self.product_id,
        scene: self.scene,
      },
        true
      )
        .then((res) => {
          self.loading = false;
          self.form.scene = self.scene;
          Object.assign(self.form, res.data);
          if (res.data.specData) {
            self.$set(self.form.model, "spec_many", res.data.specData);
          } else {
            self.$set(self.form.model, "spec_many", {
              spec_attr: [],
              spec_list: [],
            });
            self.form.model.sku = res.data.model.sku[0];
          }

          if (self.form.model.shop_label) {
            self.form.model.shop_label = self.form.model.shop_label.split(',')
          } else {
            self.form.model.shop_label = []
          }
          console.log(self.form.model.shop_label, '123')
          self.form.model.product_status = res.data.model.product_status.value;
          if (self.form.model.delivery_id == 0) {
            self.$set(self.form.model, "is_delivery_free", 0);
          } else {
            self.$set(self.form.model, "is_delivery_free", 1);
          }
          this.model.tableData = res.data.model.tableData;
          self.form.category = res.data.category.filter(i => (i.is_car_lease === 0));
          //修改时审核状态
          if (
            self.form.audit_setting.edit_audit == 1 &&
            self.form.scene != "add"
          ) {
            self.form.model.audit_status = 0;
          }
          self.$set(self.form.model, "display", []);
        })
        .catch((error) => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};
      list.forEach((item) => {
        obj[item.grade_id] = item.product_equity;
      });
      return JSON.stringify(obj);
    },

    /*提交*/
    onSubmit: function (submit_type) {
      let self = this;
      console.log(self.form.model, '发布')
      self.$refs.form.validate((valid) => {
        if (valid) {
          let params = formatModel(self.model, self.form.model);
          // 判断是否添加规格
          // console.log(params.spec_many.spec_attr.length,'params')
          // if(params.spec_many.spec_attr.length != 5){

          // }
          params.shop_label = params.shop_label.join(',')
          params.scene = self.scene;
          params.image = self.ImgKeepId(params.image);
          params.product_id = self.product_id;
          params.submit_type = submit_type;
          params.spec_many.spec_list.forEach((item) => {
            if (item.spec_form.official_website_price != 0) {
              item.spec_form.yield =
                (item.spec_form.line_price -
                  item.spec_form.official_website_price) /
                item.spec_form.official_website_price;
            }
          });
          console.log(params.spec_many.spec_list);
          // return;
          self.save_loading = true;
          PorductApi.editProduct({
            product_id: self.product_id,
            scene: self.scene,
            params: JSON.stringify(params),
          },
            true
          )
            .then((data) => {
              self.save_loading = false;
              self.$message({
                message: "保存成功",
                type: "success",
              });
              self.cancelFunc();
            })
            .catch((error) => {
              self.save_loading = false;
            });
        } else {
          self.$message({
            message: "请检查必填项是否填写完整",
            type: "error",
          });
        }
      });
    },

    /*图片数值只保留id*/
    ImgKeepId(list) {
      let arr = [];
      for (let i = 0, length = list.length; i < length; i++) {
        let obj = {
          image_id: list[i].image_id,
          file_id: list[i].file_id,
        };
        arr.push(obj);
      }
      return arr;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-setting-content {}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/edit.vue